export default "__VITE_ASSET__DheCWtCn__"